import React from 'react'
import { motion } from 'framer-motion'
import down from '../images/down_arrow.png'

function Tracks() {

const Track_chairs = [

  {
      Track:"Track 1: Networking and Communication",
      Chairs: [
        
        { 
          Name: "SANJOY DAS", 
          Organization: "INDIRA GANDHI NATIONAL TRIBAL UNIVERSITY", 
          Country: "India"
        },
        {
          Name: "H L MANDORIA",
          Organization: "Govind Ballabh Pant University of Agriculture & Technology, Pantnagar, UK",
          Country: "India"
        },
      ]
  },
  {
      Track:"Track 2: Smart Computing",
      Chairs: [
        { 
          Name: "MANOJ KUMAR GUPTA", 
          Organization: "SMVD, NEW DELHI", 
          Country: "India" 
        },
        {
          Name: "ANSHUL VARSHNEY",
          Organization: "National Physical Laboratory, Delhi",
          Country: "India"
        },
        
        
      ]
  },
  {
      Track:"Track 3: Cryptography",
      Chairs: [
        {
          Name: "AMIT KUMAR AWASTHI",
          Organization: "Gautam Buddha University",
          Country: "India"
        },
        { 
          Name: "OMPRAKASH KAIWARTYA", 
          Organization: "Nottingham Trent University", 
          Country: "UK" 
        }
        
        
      ]
  },
  {
      Track:"Track 4: Blockchain",
      Chairs: [
         { 
          Name: "KHALEEL AHMAD", 
          Organization: "MAULANA AZAD NATIONAL URDU UNIVERSITY, HYDERABAD", 
          Country: "India" 
        },
        {
          Name: "MANSAF ALAM",
          Organization: "Jamia Millia Islamia, New Delhi",
          Country: "India"
        },
        
        
        
      ]
  },
  {
      Track:"Track 5:Cyber Security",
      Chairs: [
        { 
          Name: "ANURAG JAIN", 
          Organization: "GURU GOBIND SINGH INAPRASTHA UNIVERSITY", 
          Country: "India" 
        },
        
        {
          Name: "SHAILENA PRATAP SINGH",
          Organization: "Central University of Rajastan, Rajasthan",
          Country: "India"
        },
        {
          Name: "R. K. DWIVEDI",
          Organization: "TMU, Moradabad",
          Country: "India"
        }
      ]
  },
  {
      Track:"Track 6: Intelligent System",
      Chairs: [

        {
          Name: "VIVEK SRIVASTVA",
          Organization: "NIT Uttarakhand",
          Country: "India"
        },
       
        { 
          Name: "PARMA NAND ASTYA", 
          Organization: "SHARDA UNIVERSITY", 
          Country: "India" 
        }
        
      ]
  },
  {
      Track:"Track 7: AI Based Security",
      Chairs: [
        {
          Name: "SHIKHAR VERMA",
          Organization: "Kochi University of Technology",
          Country: "Japan"
        },
        {
          Name: "ARVIND DAGUR",
          Organization: "GALGOTIAS UNIVERSITY",
          Country: "INDIA"
        },
      ]
  },
  {
      Track:"Track 8: Quantum Computing Security",
      Chairs: [
        
        { 
          Name: "B. B. SAGAR", 
          Organization: "HBTU, KANPUR, U.P.", 
          Country: "India" 
        },
        
        {
          Name: "MANISH GUPTA",
          Organization: "University of Technology Sydney",
          Country: "Australia"
        },
      ]
  },
  
];
  return (
    <div className="container">
        <motion.div className="card shadow" style={{ overflow: 'hidden', background: 'None' }}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.6, ease: 'easeOut' }}>
            <div className="card-body">
                <h1 className="card-title text-center text-danger"><strong>Call for Paper</strong></h1>
                <p className="card-text my-5" style={{textAlign:"justify"}}>NETCRYPT 2026 invites original contributions based on the results of research and developments. Prospective authors are requested to submit their papers in not more than 6 pages, as word file (docx) prepared in the double column IEEE format. All accepted and presented papers are expected to go to IEEE Xplore, and are indexed in Scopus subject to getting screened through Technical Program Integrity check, upon presentation in the Conference, following acceptance after peer review.</p>

                <h3 className="card-title text-danger"><strong>Submissions for NETCRYPT are welcomed in the following Tracks:</strong></h3>

                {/* <div className="row">
                    <div className="col-sm-6 mb-3 mb-sm-0">
                        <div className="card border-0">
                        <div className="card-body">
                            <ul>
                                <li>Wireless Sensor Network</li>
                                <li>Wireless Ad Hoc Network</li>
                                <li>Internet of Things</li>
                                <li>Internet of Every Thing</li>
                                <li>Internet of Vehicles</li>
                                <li>Body Area Network</li>
                                <li>Cloud computing</li>
                                <li>Fog Computing</li>
                                <li>Mobile Computing</li>
                                <li>Cellular Network</li>
                            </ul>
                        </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="card border-0">
                        <div className="card-body">
                            <ul>
                                <li>Delay Tolerant Network</li>
                                <li>4G/5G Networks</li>
                                <li>Cognitive Network</li>
                                <li>Satellite Communication</li>
                                <li>Block Chain</li>
                                <li>Cyber Security</li>
                                <li>Cyber Forensic</li>
                                <li>Secure Techniques using AI</li>
                                <li>Delay Tolerant Network</li>
                            </ul>
                        </div>
                        </div>
                    </div>
                    </div> */}

                    {/* <p className="card-text">Papers from other topics relevant to conference theme or the special sessions are also welcome. Submission of papers shall be through.</p> */}
            </div>
            </motion.div>

            {/* <div class="card my-5 border-0">
                <div class="card-body">
                    <figure className='text-center'>
                    <blockquote class="blockquote">
                        <h1 className='text-danger'>Tracks</h1>
                    </blockquote>
                    <figcaption class="blockquote-footer">
                        <h4>The computational science technologies we will be including are:</h4> 
                    </figcaption>
                    </figure>
                </div>
            </div> */}


            <div class="row my-5">
                    <div class="col-sm-6 mb-3 mb-sm-0">
                        <div class="card shadow-lg">
                        <div class="card-body d-grid gap-2">
                            <div className='d-grid gap-2'>
                                <p class="d-inline-flex gap-1">
                                    <a class="btn btn-outline-danger shadow w-100" data-bs-toggle="collapse" href="#collapseExample1" role="button" aria-expanded="false" aria-controls="collapseExample1">
                                        Track 1: Networking and Communication <img src={down} alt="" />
                                    </a>
                                </p>
                                    <div class="collapse" id="collapseExample1">
                                        <div class="card card-body">
                                            Wireless Sensor Network, Wireless Ad-hoc Network, Body Area Network, Cellular Network, Cognitive Network, Delay Tolerent Network, 4G/5G Networks, Neural Network, Big Data for Networks, IoT, Internet of Everything, Internet of Vehicles (IoV), Satellite Communication, Group Communication, Radio Frequency Identification(RFID), UAV, Underwater Communication and additional related topics of interest within this domain.
                                        </div>
                                    </div>

                            </div>

                            <div className='my-3 d-grid gap-2'>
                                <p class="d-inline-flex gap-2">
                                    <a class="btn btn-outline-danger shadow w-100" data-bs-toggle="collapse" href="#collapseExample2" role="button" aria-expanded="false" aria-controls="collapseExample2">
                                        Track 2: Smart Computing <img src={down} alt="" />
                                    </a>
                                </p>
                                    <div class="collapse" id="collapseExample2">
                                        <div class="card card-body">
                                            Cloud Computing, Distributed Computing, FoG Computing, Mobile Computing, Neuro Communication, Edge Computing, Neuro Computing, High Performance Computing (HPC), Human Computing Interface, Cognitive Computing and Decision Support Systems and additional related topics of interest within this domain.
                                        </div>
                                    </div>

                            </div>

                            <div className='my-3 d-grid gap-2'>
                                <p class="d-inline-flex gap-1">
                                    <a class="btn btn-outline-danger shadow w-100" data-bs-toggle="collapse" href="#collapseExample3" role="button" aria-expanded="false" aria-controls="collapseExample3">
                                        Track 3: Cryptography <img src={down} alt="" />
                                    </a>
                                </p>
                                    <div class="collapse" id="collapseExample3">
                                        <div class="card card-body">
                                           Cryptographic Algorithms, Public Key Infrastructure (PKI), Trust Management, Authentication, Stream Cipher, Block Cipher, Key Management, Confidentiality, Integrity, Non-repudiation, Privacy, Key sharing methods, Signcryption, Access control, Availability, Symmetric and Asymmetric Cryptography, Group, Ring, Field, Lattice based Cryptography and additional related topics of interest within this domain.
                                        </div>
                                    </div>

                            </div>

                            <div className='my-3 d-grid gap-2'>
                                <p class="d-inline-flex gap-1">
                                    <a class="btn btn-outline-danger shadow w-100" data-bs-toggle="collapse" href="#collapseExample4" role="button" aria-expanded="false" aria-controls="collapseExample4">
                                        Track 4: Blockchain <img src={down} alt="" />
                                    </a>
                                </p>
                                    <div class="collapse" id="collapseExample4">
                                        <div class="card card-body">
                                           Consensus Mechanism, Scalability Solutions, Privacy and Security, Blockchain in Supply Chain Management, Blockchain in Healthcare, Blockchain in Internet of Things (IoT), Blockchain in Real Estate, Blockchain in IoV, Crypto solutions, Cross Chain solutions and additional related topics of interest within this domain.
                                        </div>
                                    </div>

                            </div>

                    </div>
                </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="card shadow-lg">
                        <div class="card-body d-grid gap-1">


                            <div className='my-2 d-grid gap-2'>
                                <p class="d-inline-flex gap-1">
                                    <a class="btn btn-outline-danger shadow w-100" data-bs-toggle="collapse" href="#collapseExample5" role="button" aria-expanded="false" aria-controls="collapseExample5">
                                        Track 5: Cyber Security <img src={down} alt="" />
                                    </a>
                                </p>
                                    <div class="collapse" id="collapseExample5">
                                        <div class="card card-body">
                                           Cyber Security, Cyber Forensics, Cyber Threat Intelligence, Identity and Access Management, Cybersecurity Governance and Risk Management, Digital Forensics and Incident Response, Cyber security in Critical Infrastructure, Vulnerability Assessment, Malware Detection, Honeypot, Ethical Hacking, Cryptanalysis and additional related topics of interest within this domain.
                                        </div>
                                    </div>

                            </div>

                            <div className='my-3 d-grid gap-2'>
                                <p class="d-inline-flex gap-1">
                                    <a class="btn btn-outline-danger shadow w-100" data-bs-toggle="collapse" href="#collapseExample6" role="button" aria-expanded="false" aria-controls="collapseExample6">
                                        Track 6: Intelligent System <img src={down} alt="" />
                                    </a>
                                </p>
                                    <div class="collapse" id="collapseExample6">
                                        <div class="card card-body">
                                           Artificial Intelligence (AI), Core Computing and Accelerators, Deep Learning, Machine Learning, Generative AI (GenAI), Federated Learning, Analytics Reasoning and Sense-making on Big Data, Data Modelling and Semantic Engineering, AI based Models for FinTech, Hybrid Machine Learning Systems for Data Science, AI in Health, Medicine and FemTech, AI Recommendation systems, Scalable Computing Models, Theories, and Algorithms, AI-enabled IoT, AI in Metadata, AI in Management, AI in Agriculture, High-performance data mining algorithms and additional related topics of interest within this domain.
                                        </div>
                                    </div>

                            </div>

                            <div className='my-3 d-grid gap-2'>
                                <p class="d-inline-flex gap-1">
                                    <a class="btn btn-outline-danger shadow w-100" data-bs-toggle="collapse" href="#collapseExample7" role="button" aria-expanded="false" aria-controls="collapseExample7">
                                        Track 7: AI Based Security <img src={down} alt="" />
                                    </a>
                                </p>
                                    <div class="collapse" id="collapseExample7">
                                        <div class="card card-body">
                                           AI Based Cyber Security, AI Based Web Security, AI Based Android Security, AI Based Fuzzy Logic Based Information, AI Based Security Systems, AI Based Honey Pot, AI Based Cyber Forensics, AI Based Vulnerability Assessment, AI Based Attacks and Defenses and additional related topics of interest within this domain.
                                        </div>
                                    </div>

                            </div>

                            <div className='my-3 d-grid gap-2'>
                                <p class="d-inline-flex gap-1">
                                    <a class="btn btn-outline-danger shadow w-100" data-bs-toggle="collapse" href="#collapseExample8" role="button" aria-expanded="false" aria-controls="collapseExample8">
                                        Track 8: Quantum Computing Security <img src={down} alt="" />
                                    </a>
                                </p>
                                    <div class="collapse" id="collapseExample8">
                                        <div class="card card-body">
                                           Quantum Data, Quantum Cryptography, Quantum Computation, Quantum Communication, Quantum Technologies, Quantum Circuits, Quantum Algorithms, Quantum Error Correction, Quantum Key Distribution (QKD), Superposition and Entanglement, Quantum Sensing, Post-Quantum Cryptography, Security for Quantum Computing Applications, Quantum Machine Learning and additional related topics of interest within this domain.
                                        </div>
                                    </div>

                            </div>
                            
                        </div>
                        </div>
                    </div>
                    </div>

        <div className="mt-5 text-center" id="chairs">   
        <h3 className="card-title text-center text-danger my-5"><strong>Track Chairs for each conference track</strong></h3>
        <div class="row row-cols-1 row-cols-md-1 g-4">
        {Track_chairs.map((title, index) => (
          <div class="card shadow-lg">
              <div class="card-header">
                <h5 className="card-title text-center text-danger"><strong>{title.Track}</strong></h5>
              </div>
              <div class="card-body">
                <div class={title.Chairs.length==3?"row row-cols-1 row-cols-md-3 g-4":"row row-cols-1 row-cols-md-2 g-4"} >
                {title.Chairs.map((e,index1)=>(
                  
                  <div class="col">
                  
                    <div class="card h-100 shadow p-3" style={{backgroundColor:"#FFF5EE"}}>
                    <div class="card-body">
                        <h5 class="card-title">{e.Name}</h5>
                        <p class="card-text">{e.Organization}</p>
                        <p class="card-text">{e.Country}</p>
                    </div>
                    </div>
                </div>
                
                ))}
                </div>
              </div>
            
                
              </div>
        ))}
      </div>
      </div>

            
    </div>
  )
}

export default Tracks